<template>
  <span>
    <!--<header-login></header-login>-->
    <body-login></body-login>
    <!--<footer-login></footer-login>-->
  </span>
</template>
<script>

import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';

import HeaderLogin from '@/components/ThemeMDB/pages/loginPage/HeaderCompanyLogin';
import BodyLogin from '@/components/ThemeMDB/pages/loginPage/BodyCompanyLogin';
//import FooterLogin from '@/components/ThemeMDB/pages/loginPage/Footer';

export default {
    name: 'companyLogin',
    components:{
        HeaderLogin,
        BodyLogin
       // FooterLogin      
    },
    computed (){
this.test();

    },
    methods:{
      test(){
        console.log('testcmpny');
      }
    }
};
</script>
